export default {"src":"/_next/static/media/es-flag-icon.f0037692.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};